export const unauthorizedMiddleware = (store: any) => (next: any) => (action: any) => {
  if (action.payload?.statusCode === 401) {
    store.dispatch({ type: 'auth/clearAuthorized' })
  }
  return next(action)
}
